import { post } from '../index';

export const checkLicence = data => {
  return post('/licenses/check', data);
};
